<div class="filter-wrapper">
  <div class="button-wrapper">
    <ng-content></ng-content>
  </div>

  <div
    class="clean-filters-wrapper"
    (click)="cleanFiltersAction()"
  >
    {{ 'COMPONENTS.FILTER_WRAPPER.CLEAN_FILTERS' | translate }}
  </div>
</div>
